/**
 * AttentionBadge — red circle with "!" used to indicate items needing user action.
 *
 * Matches the notification bell badge style (bg-[#B91C1C]).
 *
 * Variants:
 * - `dot`: small indicator (e.g., on avatars, icons)
 * - `badge`: standard size with "!" (e.g., on nav items, tabs)
 */

interface AttentionBadgeProps {
  /** 'dot' for small indicator, 'badge' for standard with "!" */
  variant?: 'dot' | 'badge';
  /** Additional className */
  className?: string;
}

export function AttentionBadge({ variant = 'badge', className = '' }: AttentionBadgeProps) {
  if (variant === 'dot') {
    return (
      <span className={`h-2.5 w-2.5 rounded-full bg-[#B91C1C] ${className}`} />
    );
  }

  return (
    <span className={`h-4 w-4 rounded-full bg-[#B91C1C] text-white text-[9px] font-bold flex items-center justify-center shrink-0 ${className}`}>
      !
    </span>
  );
}
